if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        // P0 2026-10-01 Safari ATC empty-cart ROUND 2 (~2:51 ET Eli residual):
        // Prior FIXPACK still AJAX POST /cart/add → /cart.js verify → location.assign
        // OR native fallback. Safari/WebKit + ITP can still drop the AJAX Set-Cookie
        // cart cookie across soft navigation (cart.js may briefly see items; /cart empty).
        // Cookie banner Decline does NOT clear `cart` (only _shopify_y/_s/_tracking_consent),
        // but AJAX+soft-nav remains the money-path race. SAFEST: skip AJAX entirely -
        // never preventDefault; browser native POST /cart/add gets Shopify 302 Location:/cart
        // + Set-Cookie: cart= on the SAME response (atomic). Sticky-cart already native.
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          evt.preventDefault();
          return;
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        // Do NOT preventDefault - native form POST proceeds.
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
